import script from "./add_cohort_wizard.vue?vue&type=script&setup=true&lang=js"
export * from "./add_cohort_wizard.vue?vue&type=script&setup=true&lang=js"

import "./add_cohort_wizard.vue?vue&type=style&index=0&id=6f0fab88&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f0fab88"]])

export default __exports__